import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ErrorTypography = styled(Typography)`
  color: ${({ theme }) => theme.palette.error.main};
`;
